import {
  required,
  Create,
  SimpleForm,
  TextInput,
  FormDataConsumer,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { CardCampaign } from "./components";
import { CustomToolbar } from "../../../utils";

const validateRequired = required();
const fieldStyle = { width: "256px", minWidth: "256px" };

const ProjectCreate = (props) => (
  <Create redirect="list" title="Novo Projeto" {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextInput
        label="Nome do Projeto"
        source="name"
        validate={validateRequired}
        style={fieldStyle}
      />
      <FormDataConsumer>
        {({ formData }) => (
          <>
            <ReferenceInput
              sort={{ field: "name", order: "ASC" }}
              perPage={999}
              resource="group"
              source="group"
              reference="groups"
            >
              <SelectInput
                label="Grupo"
                optionText="name"
                optionValue="id"
                validate={validateRequired}
                style={fieldStyle}
              />
            </ReferenceInput>
            
            <ReferenceInput
              perPage={999}
              source="labId"
              reference="labs"
              filter={formData.group && { lab: { groupId: formData.group } }}
            >
              <SelectInput
                className="filds-container"
                label="Laboratório"
                optionValue="id"
                optionText="name"
                disabled={!formData.group}
                validate={validateRequired}
                style={fieldStyle}
              />
            </ReferenceInput>

          </>
        )}
      </FormDataConsumer>
      <CardCampaign />
    </SimpleForm>
  </Create>
);

export default ProjectCreate;
